import React from 'react';
import './NavigationBarIndicator.css';

const NavigationBarIndicator = ({indicatorposition,pageposition, navigationItems}) => (
  <div className="NavigationBarIndicator">

    <div className="IndWrapper">

      <div className="welcomei" style={{
        backgroundColor: (indicatorposition === 1||pageposition === 1) ? 'orange' : 'white',
      }}>
        {navigationItems[0]}

      </div>

      <div className="abouti" style={{
        backgroundColor: (indicatorposition === 2||pageposition === 2) ? 'orange' : 'white',
      }}>
        {navigationItems[1]}
      </div>

      <div className="offersi" style={{
        backgroundColor: (indicatorposition === 3||pageposition === 3)? 'orange' : 'white',
      }}>
        {navigationItems[2]}
      </div>


      <div className="referencesi" style={{
        backgroundColor: (indicatorposition === 4||pageposition === 4) ? 'orange' : 'white',
      }}>
        {navigationItems[3]}

      </div>

      {navigationItems.length > 4 && <div className="doctori" style={{
        backgroundColor: (indicatorposition === 5||pageposition === 5) ? 'orange' : 'white',
      }}>
        {navigationItems[4]}
      </div>}

      

      {navigationItems.length > 5 && <div className="routei" style={{
        backgroundColor: (indicatorposition === 6||pageposition === 6) ? 'orange' : 'white',
      }}>
        {navigationItems[5]}
      </div>}

      

      {navigationItems.length > 6 && <div className="contactdatai" style={{
        backgroundColor:(indicatorposition === 7||pageposition ===7) ? 'orange' : 'white',
      }}>
        {navigationItems[6]}
      </div>}

    </div>


  </div>
);

export default NavigationBarIndicator;